import {BlockCodeEditorComponent} from './block-code-editor/block-code-editor.component';

declare let Blockly;

let dialog: any;

// bg-color - #dbbdcc
const editCode = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADfklEQVRogdXaXWhbZRzH8e//yfFi1QthKLX1ZthK6QaONtixQsYsWlwLjji6CqNzW8tAYWxlBDthtZ34uovJwItZB4oy8GUwZfMFW6HTzW1pqChlI+0mXtiLFb1KKizx740pIXY5J01yntPfVeA858nvc/IcTjjnCAW5MT5db7gzgNKFyDpgbeEYS1lQ5JbA+WxW3mt6quWP/I2S+6CqMjsxFQOOAjV+tywxaRV5pXFry3ERUfgPoqoyNzF1WuF5u/1KjMrpho6WfhFRAzA7MRVbdQgA0b3J7xOHAeT6t4m6UOifJMFfTnfLIibzqAmFdIDViwBYo+rsMQpdtpuUG1G6jKANtotUII8Y4H7bLfLz2Vdf0LlnBxue3kz0hT4uXrvsZbe1hrxric2oKkdPvM7Q8VHqHqylf2cfqsq+oQP8EP/JbXeR5Hhc/ShaLKrK8DtvcObLz9n1TA/DB2IAZLNZnn1xN8YYzr77YdE5jB9FiyUfAfD15HfM/X4LgFAoxJa2dpK/zbnOYxVSiABY+OtPdg3uX8JMz/zCw7X1rnM5VWvpkuUQueQwnZEOLiWu8mZs2HU+K+dIMURherujHDt0xHWc70tLVRk9+bYnRM+27YwcfMnTvL5CcoiPzn3iOrZn23aODR7BiLeKvkGqiQCfINVGgA8QPxBQZYhfCKgixE8EVAniNwKqcGVXVUZOvsXH5z51HVspBFT4F7GFgApCbCKgQhDbCKgAJAgIKBMSFASUAQkSAlYICRoCVgAJIgJKhAQVASVAgowAj5CgI8Djf60Pzp7xhOjtjjJ6cAgR/29eejps30xOuI6xiQAPkFQ6zfT1XxnY2cemjeFlx+TudthCgAfIlZ/jZDIZOjZv4dRrJ/6HsXVOFMb12y8lrnFfzb2sb2xiJnmD9Y1NS9t6u6O8OviydQR4ONl/nLpCNptl044nSaXTOI5DeMNGOiNPsDv6nNXllB8HUIo8I1n8e5H62jraW9tob32ctsdaqVkTuEeOKsnx+ALBebthpbltAPeHD0GPMmdALtjuUW7UcMHcuUdPASnbZcpIKuMwZpoj4XkVGbHdZqURZbg5Ep5feqlmdjwxhuhe28VKivB+w9bWgaWXakREGzpa+lUkxupYZilRDucQsMz1Y2Yy/pCToV+UbmAd8IDfLe+S28BNFc5nHMaaI+H5/I3/Amrzvv/JW6aiAAAAAElFTkSuQmCC';
const DEFAULT_LINE_CHARS = 3; // default

export function OpenCodeEditorOnBlock(dialogModule) {
    dialog = dialogModule;
    const plus = new Blockly.FieldImage(editCode, 20, 20, undefined, onClick_);

    return plus;
}

function onClick_(openEditorButton) {
    const block = openEditorButton.getSourceBlock();

    if (block.isInFlyout) {
        return;
    }
    const code = block.getFieldValue('CODE');

    const dialogRef = dialog.open(BlockCodeEditorComponent, {
        width: '60%',
        height: '60%',
        data: {code: code}
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            block.setFieldValue(result, 'CODE');
        }
    });
}

export class BlocklyFieldTextbutton extends Blockly.Field {
    constructor(buttontext, changeHandler) {
        super('', null, null);

        this.buttontext_ = buttontext;
        this.changeHandler_ = changeHandler;
        this.setValue(buttontext);
    }
    clone() {
        return new BlocklyFieldTextbutton(this.buttontext_, this.changeHandler_);
    }
    showEditor_() {
        if (this.changeHandler_) {
            this.changeHandler_();
        }
    }
}

export class BlocklyFieldImagebutton extends Blockly.Field {

    src: any;
    constructor(imageSrc, changeHandler) {
        super('');

        this.size_.height = 22;
        this.size_.width = 22;
        this.src = Blockly.utils.parsing.replaceMessageReferences(imageSrc);
        this.changeHandler_ = changeHandler;
        this.setValue('');
    }
    clone() {
        return new BlocklyFieldImagebutton(this.buttontext_, this.changeHandler_);
    }
    showEditor_() {
        if (this.changeHandler_) {
            this.changeHandler_();
        }
    }
    updateSize_() {}
    positionTextElement_() {}
    positionBorderRect_() {}

    createBorderRect_() {
        this.borderRect_ = /** @type {!SVGRectElement} **/
            (Blockly.utils.dom.createSvgElement('rect',
                {
                    'rx': this.getConstants().FIELD_BORDER_RECT_RADIUS,
                    'ry': this.getConstants().FIELD_BORDER_RECT_RADIUS,
                    'x': 0,
                    'y': 0,
                    'height': '22px',
                    'width': '22px',
                    'class': 'blocklyFieldRect'
                }, this.fieldGroup_));
    }
    updateEditable() {
        var group = this.fieldGroup_;
        if (!this.EDITABLE || !group) {
            return;
        }
        Blockly.utils.dom.addClass(group, 'blocklyImageButton');
        if (this.sourceBlock_.isEditable()) {
            Blockly.utils.dom.addClass(group, 'blocklyEditableText');
            Blockly.utils.dom.removeClass(group, 'blocklyNonEditableText');
            group.style.cursor = this.CURSOR;
        } else {
            Blockly.utils.dom.addClass(group, 'blocklyNonEditableText');
            Blockly.utils.dom.removeClass(group, 'blocklyEditableText');
            group.style.cursor = '';
        }
    };
    createTextElement_() {
        this.textElement_ = /** @type {!SVGImageElement} */
            (Blockly.utils.dom.createSvgElement(
                'image',
                {
                    'height': 18 + 'px',
                    'width': 18 + 'px',
                    'alt': '*',
                    'x': '2',
                    'y': '2'
                },
                this.fieldGroup_));
        this.textElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS,
            'xlink:href', /** @type {string} */ (this.src));

        if (this.clickHandler_) {
            this.imageElement_.style.cursor = 'pointer';
        }

        // this.textContent_ = document.createElement('img');
        // this.textContent_.setAttribute('src', this.src);
        // this.textContent_.setAttribute('alt', '*');
        // this.textContent_.setAttribute('height', '20px');
        // this.textContent_.setAttribute('width', '20px');
        // this.textElement_.appendChild(this.textContent_);
    }
}


// Field to display the code
export class CodeDisplayField extends Blockly.FieldMultilineInput {
    /**
     * Constructs a FieldTextBox.
     * @param {!String} value A JSON object with options.
     * @param {Function} validator A JSON object with options.
     * @param {Object} options A JSON object with options.
     * @extends {Blockly.FieldMultilineInput}
     * @constructor
     */
    constructor(value, validator, options) {
        super(value, validator, options);
        const _options = {...options};
        const maxLineChars = Math.abs(parseInt(_options.maxLineChars, 10));
        this.maxLineChars_ = maxLineChars || DEFAULT_LINE_CHARS;
        this.closeOnEnter_ = _options.closeOnEnter === true;
    }

    initView() {
        super.initView();
        this.createBorderRect_();
        this.textGroup_ = /** @type {!SVGGElement} **/
            (Blockly.utils.dom.createSvgElement('g',
                {
                    'class': 'blocklyEditableText blocklyCodeDisplay',
                }, this.fieldGroup_));
    };

    /**
     * Get the text from this field as displayed on screen.
     * @return {string} Currently displayed text.
     * @protected
     * @override
     */
    getDisplayText_() {
        var value = this.value_;
        if (value !== '') {
            if (!value) {
                // Prevent the field from disappearing if empty.
                return Blockly.Field.NBSP;
            }
            var lines = value.split('\n');
            value = '';
            for (var i = 0; i < lines.length; i++) {
                var text = lines[i];
                if (text.length > this.maxDisplayLength) {
                    // Truncate displayed string and add an ellipsis ('...').
                    text = text.substring(0, this.maxDisplayLength - 4) + '...';
                }
                // Replace whitespace with non-breaking spaces so the text doesn't collapse.
                text = text.replace(/\s/g, Blockly.Field.NBSP);

                if (lines.length <= 3) {
                    value += text;
                    if (i !== lines.length - 1) {
                        value += '\n';
                    }
                } else {
                    if (i <= 2) {
                        value += text;
                        value += '\n';
                    }
                    if (i === lines.length - 1) {
                        value += '...';
                    }
                }
            }
        } else {
            value = 'Enter your code here -->';
        }
        if (this.sourceBlock_.RTL) {
            // The SVG is LTR, force value to be RTL.
            value += '\u200F';
        }
        return value;
    }

    widgetCreate_() {
        var div = Blockly.WidgetDiv.DIV;
        var scale = this.workspace_.getScale();

        var htmlInput =
            /** @type {HTMLTextAreaElement} */ (document.createElement('textarea'));
        htmlInput.readOnly = true;
        htmlInput.className = 'blocklyHtmlInput blocklyCodeAreaInput';
        htmlInput.setAttribute('spellcheck', this.spellcheck_);
        var fontSize = (this.getConstants().FIELD_TEXT_FONTSIZE * scale) + 'pt';
        div.style.fontSize = fontSize;
        htmlInput.style.fontSize = fontSize;
        var borderRadius = (Blockly.FieldTextInput.BORDERRADIUS * scale) + 'px';
        htmlInput.style.borderRadius = borderRadius;
        var paddingX = this.getConstants().FIELD_BORDER_RECT_X_PADDING * scale;
        var paddingY = this.getConstants().FIELD_BORDER_RECT_Y_PADDING * scale / 2;
        htmlInput.style.padding = paddingY + 'px ' + paddingX + 'px ' + paddingY +
            'px ' + paddingX + 'px';
        var lineHeight = this.getConstants().FIELD_TEXT_HEIGHT +
            this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
        htmlInput.style.lineHeight = (lineHeight * scale) + 'px';

        div.appendChild(htmlInput);

        htmlInput.value = htmlInput.defaultValue = this.getEditorText_(this.value_);
        // htmlInput.untypedDefaultValue_ = this.value_;
        // htmlInput.oldValue_ = null;
        if (Blockly.utils.userAgent.GECKO) {
            // In FF, ensure the browser reflows before resizing to avoid issue #2777.
            setTimeout(this.resizeEditor_.bind(this), 0);
        } else {
            this.resizeEditor_();
        }

        this.bindInputEvents_(htmlInput);

        return htmlInput;
    }
}

// Changing source code to reduce undefined error
Blockly.InsertionMarkerManager.prototype.createMarkerBlock_ = function (a) {
    var b = a.type;
    Blockly.Events.disable();
    try {
        var c = this.workspace_.newBlock(b);
        c.setInsertionMarker(!0);
        if (a.mutationToDom) {
            var d = a.mutationToDom();
            d && c.domToMutation(d)
        }
        for (b = 0; b < a.inputList.length; b++) {
            var e = a.inputList[b];
            if (e.name != Blockly.Block.COLLAPSED_INPUT_NAME) {
                var f = c.inputList[b];
                for (d = 0; d < e.fieldRow.length; d++)
                    //AS 2020-10-16
                    if (f &&f.fieldRow && f.fieldRow[d] ){
                        f.fieldRow[d].setValue(e.fieldRow[d].getValue())
                    }
            }
        }
        c.setCollapsed(a.isCollapsed());
        c.setInputsInline(a.getInputsInline());
        c.initSvg();
        c.getSvgRoot().setAttribute("visibility", "hidden");
    } finally {
        Blockly.Events.enable();
    }
    return c;
};

// Changing source code to reduce undefined color attribute console warnings
Blockly.Toolbox.prototype.setColour_ = function(colourValue, childOut,
                                                categoryName) {
    // Decode the colour for any potential message references
    // (eg. `%{BKY_MATH_HUE}`).
    var colour = Blockly.utils.parsing.replaceMessageReferences(colourValue);
    if (colour == null || colour === '') {
        // No attribute. No colour.
        childOut.hexColour = '';
    } else {
        var hue = Number(colour);
        if (!isNaN(hue)) {
            childOut.hexColour = Blockly.hueToHex(hue);
            this.hasColours_ = true;
        } else {
            var hex = Blockly.utils.colour.parse(colour);
            if (hex) {
                childOut.hexColour = hex;
                this.hasColours_ = true;
            } else {
                childOut.hexColour = '';
                console.warn('Toolbox category "' + categoryName +
                    '" has unrecognized colour attribute: ' + colour);
            }
        }
    }
};
